export default __webpack_public_path__ + "static/media/Royal-MP.115ded11.jpg";